<script>
import ThumbnailCarComponent from "../../layout/NewVehicles/ThumbnailCarComponent";

export default {
  props: {
    page: Number,
    total: Number,
    likes: Array,
    totalProducts: {
      type: Number,
      default: 0
    },
    totalItems: {
      type: Number,
      default: 0
    },
    vehicles: {
      type: Array,
      required: true,
      default: []
    },
  },

  data() {
    return {
      advertising: null,
      number: "",
      pageCurr: 1,
      size: 10,
      products: [],
      isSignUpModalVisible: true
    };
  },

  components: {
    ThumbnailCarComponent,
  },

  watch: {
    vehicles: {
      handler(newValue) {
        this.products = newValue;
      },
    },
  },

  computed: {
    productsViewPrimary() {
      //[Legacy logic] This function creates rows on mkt_stats_views table, which is useless for autodeal business
      // this.setViews(this.products);
      return this.products.slice(0, 12);
    },

    productsViewSecond() {
      return this.products.slice(12);
    },

    pagesTotal() {
      return this.total;
    },

    currentPage() {
      return this.page;
    },

    sizeProducts() {
      return this.size < this.totalItems;
    }
  },

  created() {
    if(this.vehicles) {
      this.products = this.vehicles;
    }
    let likedCars = []
    // likedCars = likedCars.concat(this.likes, (JSON.parse(localStorage.getItem('likes')) ?? []))
    likedCars = JSON.parse(localStorage.getItem('likes')) ?? []

    this.likes.forEach(el => {

      let result = likedCars.find(elc => el.mkt_brand_new_vehicle_id == elc.mkt_brand_new_vehicle_id)

      if(!result) likedCars.push(el)
    })

    localStorage.setItem('likes', JSON.stringify(likedCars));
    console.log(likedCars);
  },

  methods: {
    showSignUpModal() {
      this.$emit('showSignUpModal')
    },
    showErrors(error = null) {
      let vm = this;
      if (error) {
        vm.err = error.response.data;
      }
      vm.$swal({
        icon: "error",
        title: "Error",
        text: vm.err.message
          ? vm.err.message
          : "Se encontraron algunos errores en el formulario",
      });
    },

    async getAdvertisingAsync() {
      let { data } = await axios.get("/catalogo/advertising");
      this.advertising = data;
    },

    resetForms() {
      this.formData = new FormData();
      this.err = [];
    },

    hasResults() {
      return (
        this.productsViewPrimary.length == 0 &&
        this.productsViewSecond.length == 0
      );
    },

    async setViews(products) {
      let vm = this;
      vm.formData = new FormData();
      try {
        var products_ids = _.map(products, function (product) {
          return product.id;
        });

        if (products_ids.length > 0) {
          vm.formData.set("products", products_ids);
          let { data } = await axios.post("catalogo/views", vm.formData);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async infinityLoading($state) {
      if( this.sizeProducts ) {
        const url = new URL(window.location.href);
        this.size = this.size*1 + 24;
        var milocal = location.search.replace(
          `page=${parseInt(url.searchParams.get("page"))}`,
          `page=${this.pageCurr}`
        );
        var milocal = location.search.replace(
          `size=${parseInt(url.searchParams.get("size"))}`,
          `size=${this.size}`
        );
        let CurrentUrl = location.pathname + "/filters" + milocal;
        history.replaceState({ var: milocal }, "Búsqueda", milocal);

        try {
          let vm = this;
          let { data } = await axios.get(CurrentUrl);
          this.products = data.products;

          vm.$emit('newResults', {
                        products: data.products,
                        lastPage: data.lastPage,
                        currentPage: data.currentPage,
                        total: data.total
                    });

          $state.loaded();
        } catch (error) {
          console.error(error);
        }
      }
      else {
          $state.complete();
      }
    },
  },

  mounted() {
    this.number = _.sample(process.env.MIX_NUMBERS_WHATSAPP.split(","));
  },
};
</script>

<template>
  <div>
    <!-- WITHOUT RESULTS -->
    <div
      v-if="hasResults()"
      class="tx-12 md:tx-16 tx-dark-ad tx-center weight-500 line-h-soft py-25 lg:py-54 xl:py-64"
    >
      Lo sentimos, no he encontrado ningún auto. Puedes intenter cambiado tus
      <br class="hidden md:block" />
      filtros de búsqueda.
    </div>

    <div v-else>
      <div class="main__catalog grid">
        <thumbnail-car-component
          v-for="(product, key) in productsViewPrimary"
          @showSignUpModal="showSignUpModal()"
          :key="key"
          :product="product"
          :likes="likes"
        ></thumbnail-car-component>
      </div>
      <div class="container">
        <img
          class="my-img"
          src="/assets/images/pages/search/Atencion-personalizada.jpg"
        />
        <div class="gs:grid">
          <div class="centered">
            <div>
              <p class="text-dinamic">Recibe atención personalizada</p>
            </div>
          </div>
        </div>
      </div>

      <div class="main__catalog grid">
        <thumbnail-car-component
          v-for="(product, key) in productsViewSecond"
          @showSignUpModal="showSignUpModal()"
          :key="key"
          :product="product"
          :likes="likes"
        ></thumbnail-car-component>
      </div>
      <infinite-loading spinner="waveDots" @infinite="infinityLoading">
          <div slot="no-more"><span style="visibility: hidden;"></span></div>
          <div slot="no-results"></div>
      </infinite-loading>

    </div>
  </div>
</template>

<style  scoped>
.container {
  position: relative;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-10%, -50%);
}
.text-dinamic {
  font-size: 23px;
  color: #000000;
}
.my-img {
  width: 100%;
  max-height: 350px;
  border-radius: 5px;
}

@media only screen and (max-width: 600px) {
  .text-dinamic {
    font-size: 13.5px;
  }
}
</style>
